module.exports = __webpack_public_path__ + "img/7.0b18c572.svg";